import React from 'react';
import {PossibleCurrencies} from '../../@types/services/Formatter/PossibleCurrencies';
import {ICurrencyModel} from '../../@interfaces/models/Currency/ICurrencyModel';
import {formatPrice} from '../../helpers/formatters/prices/formatPrice';
import {RequireAtLeastOne} from '../../@types/RequireAtLeastOne';

export default function FormattedPrice(props: RequireAtLeastOne<{
    amount: number | string,
    children: number,
    currency?: PossibleCurrencies | ICurrencyModel | null,
    tag?: string | React.ComponentType,
    onlySign?: boolean
}, 'amount' | 'children' | 'onlySign'>) {
    const Wrapper = props.tag ?? React.Fragment;
    const amount = props.amount ?? props.children ?? 0;

    let content: string;
    if ('onlySign' in props && props.onlySign !== false) {
        content = formatPrice(0, props.currency).replace(/[\d,.]+/gui, '').trim();
    } else {
        content = formatPrice(amount, props.currency);
    }

    return <Wrapper>{content}</Wrapper>;
}
